import React from "react";

// Tus componentes
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import Typography from "@material-ui/core/Typography";

const HEADER_COLOR = "#13816F"; // color principal
const HEADER_LIGHT = "#CDE8E3"; // derivado
const HEADER_LIGHTER = "#E7F4F1"; // más claro

export default function ReportComparison({
  title = "",
  info = null,
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  const now = new Date().toLocaleString();

  const isRowExcluded = (name) =>
    [
      "Agency Site Policy Fee",
      "Consumer Site Policy Fee",
      "Total Policy Fee",
      "IVA",
      "Total Sales",
    ].includes(name);

  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      {/* Hidden form fields */}
      <form id="report_form">
        {Object.entries(forma).map(([name, value]) => (
          <input key={name} type="hidden" name={name} value={value} readOnly />
        ))}
      </form>

      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "white", borderRadius: 8 }}
            >
              {/* Header Section */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={12} md={6}>
                  <Typography variant="h6">
                    {report_tz &&
                      `${timezones[report_tz]} - ${report_tz.toUpperCase()}`}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(6, "pdf")}
                        sx={{ ml: 2 }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(6, "csv")}
                        sx={{ ml: 2 }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        color="success"
                        style={{
                          backgroundColor: "#FFF",
                          borderColor: "#13816F",
                          color: "#13816F",
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>

              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {now}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20, marginTop: -10 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>

              {/* TABLE */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {/* Header General */}
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        style={{
                          background: HEADER_COLOR,
                          color: "#FFF",
                          fontWeight: "bold",
                          fontSize: "1.1rem",
                        }}
                      >
                        {info?.agency?.code} - {info?.agency?.name}
                      </TableCell>
                    </TableRow>

                    {/* Titles Row */}
                    <TableRow style={{ background: HEADER_LIGHT }}>
                      <TableCell></TableCell>
                      <TableCell colSpan={2} style={{ textAlign: "center" }}>
                        {info?.title_from}
                      </TableCell>
                      <TableCell colSpan={2} style={{ textAlign: "center" }}>
                        {info?.title_to}
                      </TableCell>
                      <TableCell colSpan={2} style={{ textAlign: "center" }}>
                        Difference
                      </TableCell>
                    </TableRow>

                    {/* Subtitles */}
                    <TableRow style={{ background: HEADER_LIGHT }}>
                      <TableCell></TableCell>
                      <TableCell>Policy Count</TableCell>
                      <TableCell>Premium</TableCell>
                      <TableCell>Policy Count</TableCell>
                      <TableCell>Premium</TableCell>
                      <TableCell>Policy Count</TableCell>
                      <TableCell>Premium</TableCell>
                    </TableRow>

                    {/* Rows */}
                    {info?.details &&
                      Object.entries(info.details).map(
                        ([rowName, rowVal], index) => {
                          const strongLabel = [0, 1, 2, 7].includes(index);

                          return (
                            <TableRow key={rowName}>
                              <TableCell>
                                {strongLabel ? (
                                  <strong>{rowName}</strong>
                                ) : (
                                  rowName
                                )}
                              </TableCell>

                              {/* FROM */}
                              <TableCell>
                                {!isRowExcluded(rowName) ? rowVal[1].count : ""}
                              </TableCell>
                              <TableCell>
                                $
                                {Number(rowVal[1].premium).toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                  }
                                )}
                              </TableCell>

                              {/* TO */}
                              <TableCell>
                                {!isRowExcluded(rowName) ? rowVal[2].count : ""}
                              </TableCell>
                              <TableCell>
                                $
                                {Number(rowVal[2].premium).toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                  }
                                )}
                              </TableCell>

                              {/* DIFFERENCE */}
                              <TableCell>
                                {!isRowExcluded(rowName)
                                  ? rowVal[1].count - rowVal[2].count
                                  : ""}
                              </TableCell>
                              <TableCell>
                                $
                                {Number(
                                  rowVal[1].premium - rowVal[2].premium
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                })}
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Bottom Buttons */}
              <GridContainer style={{ marginTop: 20 }}>
                <GridItem xs={12} sm={12} md={6}>
                  &nbsp;
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(6, "pdf")}
                        sx={{ ml: 2 }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(6, "csv")}
                        sx={{ ml: 2 }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        type="submit"
                        color="success"
                        style={{
                          backgroundColor: "#FFF",
                          borderColor: "#13816F",
                          color: "#13816F",
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
